import { AiOutlineThunderbolt } from "react-icons/ai";
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const { openConnectModal } = useConnectModal();
  const { isConnected } = useAccount();
  const navigate = useNavigate();

  const handleStartBetting = () => {
    if (isConnected) {
      navigate('/app');
    } else if (openConnectModal) {
      openConnectModal();
    }
  };

  return (
    <section className="hero">
      <div className="hero-background"></div>
      <div className="container">
        <div className="hero-content">
          <p className="hero-powered">
            <AiOutlineThunderbolt size={24} color="var(--color-yellow)" />
            Powered by Web3 - USDC
          </p>
          <h1 className="hero-title">
            The video <span className="text-gradient">prediction</span>
            <br />
            arena
          </h1>
          <p className="hero-subtitle">
            Bet on viral videos. Win real rewards. Powered by blockchain.
          </p>
          <div className="hero-actions">
            <button
              className="btn btn-primary btn-lg"
              onClick={handleStartBetting}
            >
              Start Betting
            </button>
            <a className="btn btn-secondary btn-lg" href="#how-it-works">Learn More</a>
          </div>
        </div>
      </div>
    </section>
  );
}

